import { differenceInDays, formatDistanceToNowStrict } from 'date-fns';
import DateFnLocale from './DateFnLocale';

/**
 * @param {Date} lastLogin
 * @param {string} lastLoginFormatted
 * @param {string} locale locale key
 * @returns {string}
 */
export default function getLastLoginContent(lastLogin, lastLoginFormatted, locale) {
    if (!lastLogin || !locale) {
        return '';
    }
    const diffDays = differenceInDays(Date.now(), lastLogin);
    if (diffDays <= 7) {
        return formatDistanceToNowStrict(lastLogin, {
            addSuffix: true,
            locale: DateFnLocale[locale],
        });
    }
    return lastLoginFormatted;
}
